import { Box, Typography } from "@mui/material";
import useIsLargeScreen from "../hooks/useIsLargeScreen";
import AgenciesTable from "../components/AgenciesTable";

const AgenciesListPage = () => {
    const isLargeScreen = useIsLargeScreen();

    return (
        <>
            <Box sx={{ marginTop: "2rem", margin: ( isLargeScreen ?  3 : 2 )}}>
                <Typography component="h1" variant="h4" gutterBottom>Agencies</Typography>
                <AgenciesTable />
            </Box>
        </>
    );
};

export default AgenciesListPage;